const options = {
  5: "bg-green-800/5",
  10: "bg-green-800/10",
  25: "bg-green-800/25",
  50: "bg-green-800/50",
  75: "bg-green-800/75",
  90: "bg-green-800/90",
  100: "bg-green-800",
};

const from = {
  5: "from-green-800/5",
  10: "from-green-800/10",
  25: "from-green-800/25",
  50: "from-green-800/50",
  75: "from-green-800/75",
  90: "from-green-800/90",
  100: "from-green-800",
};

export default function getBackgroundGreen800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
